import React, { Component } from "react";
import OTPInput, { ResendOTP } from "otp-input-react";
import { connect } from "react-redux";
import { validateOtp } from "../../actions/login/loginActions";
import {
  loginOTP,
  resetOtpState
} from "../../actions/login/otpActions";
import { decryptId } from "../Decryption";

class OtpPage extends Component {
  state = { OTP: "", timer: 30 };

 componentWillUnmount() {
    this.props.resetOtpState();
  }
 
    renderButton = (buttonProps) => {
      const { disabled, ...otherProps } = buttonProps; // Exclude `remainingTime` and others
      return !disabled && (
        <button
          {...otherProps}
          className={disabled ? "btnMainDisabled" : "btnMain loginBtn"}
        >
          Resend
        </button>
      );
    };
    
    renderTime = (remainingTime) => {
      return remainingTime > 0 ? (
        <h5>Kindly Wait {remainingTime} seconds to Resend OTP</h5>
      ) : null;
    };
    

  onOtpChange = (otp) => {
    this.setState({ OTP: otp });
  };
  getOTP = async (e) => {
     e.preventDefault();
     await this.props.loginOTP(this.state.username);
   };
  validateOtp = () => {
    const { OTP } = this.state;
    if (OTP === "") {
      alert("Please enter the OTP");
    } else if (OTP.length < 4) {
      alert("The OTP must be 4 digits long");
    } else {
      this.props.validateOtp(this.props.username, OTP);
      this.setState({ OTP: "" });
    }
  };

  resendOtp = () => {
    // Add your resend OTP logic here
    alert("OTP resent!");
    this.startTimer(); // Restart the timer after resending OTP
  };

  render() {
    const { timer, OTP } = this.state;

    return (
      <div>
        <img
          className="loginImage"
          src="/assets/images/LoginPage1.png"
          alt="Login Page"
        />
        <div className="loginContainer">
          <div>
            <h3 className="loginTitle">Enter OTP</h3>
            <div className="clearfix">
              <div className="form-group">
                <h5>Enter OTP</h5>
                <OTPInput
                  value={OTP}
                  onChange={this.onOtpChange}
                  OTPLength={4}
                  inputClassName="otpInput"
                  otpType="number"
                  disabled={false}
                />
                  <ResendOTP
                    maxTime={30}
                    renderButton={(props) => {
                      const { remainingTime, ...buttonProps } = props; // Exclude `remainingTime`
                      return this.renderButton(buttonProps);
                    }}
                    renderTime={(remainingTime) => this.renderTime(remainingTime)}
                    onResendClick={() => this.props.loginOTP(decryptId(this.props.otp.username))}
                  />

                {this.props.otp.message ? (
                      <p className="pt-5">{this.props.otp.message}</p>
                    ) : (
                      <></>
                    )}
                <div className="d-block mt-3">
               
                  <button
                    className="btnMain loginBtn mb-3"
                    onClick={this.validateOtp}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  debugger;
  return {
    username: state.otp.username,
     otp: state.otp,
  };
};


export default connect(mapStateToProps, { validateOtp,loginOTP,resetOtpState })(OtpPage);